module.exports = __webpack_public_path__ + "img/video.af0ce69a.png";